import type { FC, ReactNode } from 'react'
import type { CartProduct } from '../../shopping-cart/provider/types'
import PrpsDubiPrice from '../PrpsDubiPrice'
import ShopItemImage from '../ShopItemImage'
import { PurchaseCategory, PurchaseType } from '@g4g/graphql/src/shop/__generated__/globalTypes'
import ProductEdit from './ProductEdit'
import ProductBadge from './ProductBadge'
import { classNames } from '@g4g/utils/src/react/class-names'
import { shopItemWithSkin } from '@g4g/utils/src/gameDataUtils'
import ShopItemLink from '../ShopItemLink'

const ProductPrice: FC<{
  product: CartProduct
}> = ({ product }) => (
  <div className="mt-2 leading-6">
    <PrpsDubiPrice
      prices={product.product.lootRewardPackage.productPrice}
      parentClassName="flex flex-row space-x-2"
      tokenLogoClass="w-5 h-5"
    />
  </div>
)

const ProductDetails: FC<{
  product: CartProduct
  variant?: 'cart' | 'history'
  children?: ReactNode
}> = ({ product, variant = 'cart', children }) => (
  <div className="flex w-full ml-0">
    {/* Icon on the left. */}
    <ShopItemLink
      kebabOrShopItem={product.product.kebabName}
      className={classNames(
        'block w-[100px] mr-4',
        shopItemWithSkin(product.product.shopItemId) ? 'h-[150px]' : 'h-[100px]'
      )}
    >
      <ShopItemImage
        shopItem={product.product}
        type="front"
        width={100}
        height={shopItemWithSkin(product.product.shopItemId) ? 150 : 100}
      />
    </ShopItemLink>
    {/* Name + quantity picker + price on the right. */}
    <div className="flex flex-col grow">
      <h4 className="flex mb-2 space-x-2 font-medium text-white sm:leading-6 xl:leading-8 sm:text-lg">
        <span>{product.product.name}</span>
        {product.product.purchaseCategory === PurchaseCategory.Bundle && (
          <ProductBadge color="purple">bundle</ProductBadge>
        )}
        {product.product.purchaseType === PurchaseType.Subscription && (
          <ProductBadge color="blue">subscription</ProductBadge>
        )}
      </h4>
      <ProductEdit variant={variant} product={product}>
        {children}
      </ProductEdit>
      {variant === 'cart' && <ProductPrice product={product} />}
    </div>
  </div>
)

export default ProductDetails
